export async function probeRequestTest(
  origin: string = location.origin,
  timeout = 2500
): Promise<boolean> {
  const ctrl = new AbortController();
  const tid = window.setTimeout(() => ctrl.abort(), timeout);

  try {
    const res = await fetch(`${origin}/api/ng/request_test`, {
      method: "GET",
      cache: "no-store",
      credentials: "omit",
      signal: ctrl.signal,
    });
    if (!res.ok) return false;

    const text = (await res.text()).trim();
    return text === "test_okay";
  } catch {
    return false;
  } finally {
    window.clearTimeout(tid);
  }
}
